// extracted by mini-css-extract-plugin
module.exports = {"tabList":"MyOrders_tabList__30reQ","categorySection":"MyOrders_categorySection__1M7ui"};